import React from "react";
import { Dialog, Classes } from "@blueprintjs/core";
import {useTranslation} from "react-i18next";

// Components
import Button from "../common/components/button";

// Actions
import {deleteClient} from "./clients-actions";
import {useDispatch} from "react-redux";

// Redux dispatch hook
const useReduxDispatch = () => {
    const dispatch = useDispatch();
    return {
        deleteClient: (client) => dispatch(deleteClient(client))
    }
};

const DeleteClientDialog = (props) => {
    const {isOpen, onClose, client} = props;
    const {name, nif} = client;

    // Redux
    const {deleteClient} = useReduxDispatch();

    // i18n
    const {t} = useTranslation("clients");

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            lazy={true}
            style={{
                backgroundColor: "white",
                paddingBottom: "40px"
            }}
        >
            <div
                style={{margin: "20px 40px"}}
                className={Classes.DIALOG_BODY}
            >
                <h3 style={{margin: "20px 0"}}>{t("deleteClientDialog.title")}</h3>
                <h4 style={textStyle}>{name}</h4>
                <p>
                    {t("deleteClientDialog.sap")} <b>{client.sap_id}</b><br/>
                    {t("deleteClientDialog.nif")} <b>{nif}</b>
                </p>
                <p>{t("deleteClientDialog.text1")}</p>
                <p>{t("deleteClientDialog.text2")}</p>
            </div>
            <div
                style={{margin: "20px 40px 0 40px"}}
                className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button
                        text={t("editClientDialog.input.cancel")}
                        action={onClose}
                        intent={"cancel"}
                        style={{
                            marginRight: "15px",
                        }}
                    />
                    <Button
                        text={t("deleteClientDialog.delete")}
                        action={() => {
                            deleteClient({name, _id: client._id});
                            onClose();
                        }}
                        intent={"primary"}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteClientDialog;

const textStyle = {
    color: "#4796cb"
};